import { render, staticRenderFns } from "./StarOutline.vue?vue&type=template&id=3a0ad9db&"
import script from "./StarOutline.vue?vue&type=script&lang=js&"
export * from "./StarOutline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports